import { defineMessages } from 'react-intl-next';

export const i18n: {
    verified: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	verified: {
		id: 'search-page.filters.names.verified',
		defaultMessage: 'Verified',
		description: 'Label for filtering for Verified content',
	},
});
